// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatArea, getLocaleByCountry } from '../../../../utils/strings';
import messages from './messages';
import { item } from '../shared/styles';

type Props = {
  rooms?: number,
  bathrooms?: number,
  floorArea?: number,
  country?: Object,
  isRTL: boolean,
};

export default function FeaturesHomes({
  rooms,
  bathrooms,
  floorArea,
  country,
  isRTL,
}: Props): React.Node {
  return (
    <React.Fragment>
      {rooms && (
        <li>
          <span itemProp="numberOfRooms" className="value">
            {rooms}
          </span>
          <span className="name">
            <FormattedMessage {...messages.roomsAbrev} />
          </span>
        </li>
      )}
      {bathrooms && (
        <li>
          <span className="value">{bathrooms}</span>
          <span className="name">
            <FormattedMessage {...messages.bathroomsAbrev} />
          </span>
        </li>
      )}
      {floorArea && !isRTL && (
        <li>
          <span itemProp="floorSize" className="value">
            {country && formatArea(floorArea, null, getLocaleByCountry(country))}
          </span>
          <span className="name">
            <FormattedMessage {...messages.areaMetric} />
          </span>
        </li>
      )}
      {floorArea && isRTL && (
        <li>
          <span itemProp="floorSize" className="value">
            {floorArea}
          </span>
          <span className="name">
            <FormattedMessage {...messages.areaMetric} />
          </span>
        </li>
      )}
      <style jsx>{item}</style>
    </React.Fragment>
  );
}

FeaturesHomes.defaultProps = {
  rooms: null,
  bathrooms: null,
  floorArea: null,
  country: null,
};



// WEBPACK FOOTER //
// ./app/components/mobile/Features/homes/index.js